import React from 'react'

const ProductAttributePage = React.lazy(() => import('pages/ProductAttribute/ProductAttributePage'));
const ProductAttributeAddPage = React.lazy(() => import('pages/ProductAttribute/ProductAttributeAddPage'));

const ProductAttributeRoutes = [
    {
        path: '/product-attributes',
        exact: true,
        name: 'Thuộc tính sản phẩm',
        function: 'PRO_PRODUCTATTRIBUTE_VIEW',
        component: ProductAttributePage,
    },
    {
        path: '/product-attributes/add',
        exact: true,
        name: 'Thêm mới thuộc tính',
        function: 'PRO_PRODUCTATTRIBUTE_ADD',
        component: ProductAttributeAddPage,
    },
    {
        path: '/product-attributes/edit/:id',
        exact: true,
        name: 'Chỉnh sửa thuộc tính',
        function: 'PRO_PRODUCTATTRIBUTE_EDIT',
        component: ProductAttributeAddPage,
    },
    {
        path: '/product-attributes/detail/:id',
        exact: true,
        name: 'Chi tiết thuộc tính',
        function: 'PRO_PRODUCTATTRIBUTE_VIEW',
        component: ProductAttributeAddPage,
    },
]

export default ProductAttributeRoutes
